import APIService from "@/http.js";
const API = new APIService();

export default {
  async getPublicConfig() {
    let res = await API.get("/api/config");
    return res.data;
  },
};
